/**
 * Constant values for EditorManager
 */
/**
 * Image plugin events
 *
 * @hidden
 */
export const IMAGE = 'INSERT-IMAGE';
export const AUDIO = 'INSERT-AUDIO';
export const VIDEO = 'INSERT-VIDEO';
export const TABLE = 'INSERT-TABLE';
export const LINK = 'INSERT-LINK';
export const INSERT_ROW = 'INSERT-ROW';
export const INSERT_COLUMN = 'INSERT-COLUMN';
export const DELETEROW = 'DELETE-ROW';
export const DELETECOLUMN = 'DELETE-COLUMN';
export const REMOVETABLE = 'REMOVE-TABLE';
export const TABLEHEADER = 'TABLE-HEADER';
export const TABLE_VERTICAL_ALIGN = 'TABLE_VERTICAL_ALIGN';
export const TABLE_MERGE = 'TABLE_MERGE';
export const TABLE_VERTICAL_SPLIT = 'TABLE_VERTICAL_SPLIT';
export const TABLE_HORIZONTAL_SPLIT = 'TABLE_HORIZONTAL_SPLIT';
export const TABLE_STYLES = 'TABLE_STYLES';
export const TABLE_BACKGROUND_COLOR = 'TABLE_BACKGROUND_COLOR';
export const TABLE_MOVE = 'TABLE_MOVE';
/**
 * Alignments plugin events
 *
 * @hidden
 */
export const ALIGNMENT_TYPE = 'alignment-type';
/**
 * LineHeight plugin events
 *
 * @hidden
 */
export const LINE_HEIGHT_TYPE = 'line-height-type';
/**
 * Indents plugin events
 *
 * @hidden
 */
export const INDENT_TYPE = 'indent-type';
/**
 * Constant tag names
 *
 * @hidden
 */
export const DEFAULT_TAG = 'p';
/**
 * @hidden
 */
export const BLOCK_TAGS = ['address', 'article', 'aside', 'audio', 'blockquote',
    'canvas', 'details', 'dd', 'div', 'dl', 'dt', 'fieldset', 'figcaption', 'figure', 'footer',
    'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'li', 'main', 'nav',
    'noscript', 'ol', 'output', 'p', 'pre', 'section', 'table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr', 'ul', 'video', 'body', 'colgroup', 'summary', 'legend', 'dialog', 'menu'];
/**
 * @hidden
 */
export const IGNORE_BLOCK_TAGS = ['td', 'th'];
/**
 * @hidden
 */
export const TABLE_BLOCK_TAGS = ['table', 'tbody', 'td', 'tfoot', 'th',
    'thead', 'tr'];
/**
 * Selection plugin events
 *
 * @hidden
 */
export const SELECTION_TYPE = 'selection-type';
/**
 * Insert HTML plugin events
 *
 * @hidden
 */
export const INSERTHTML_TYPE = 'inserthtml-type';
/**
 * Insert Text plugin events
 *
 * @hidden
 */
export const INSERT_TEXT_TYPE = 'insert-text-type';
/**
 * Clear Format HTML plugin events
 *
 * @hidden
 */
export const CLEAR_TYPE = 'clear-type';
/**
 * Self closing tags
 *
 * @hidden
 */
export const SELF_CLOSING_TAGS = ['area', 'base', 'br', 'embed', 'hr', 'img', 'input', 'param', 'source', 'track', 'wbr', 'iframe', 'td', 'table'];
/**
 * Source
 *
 * @hidden
 */
export const PASTE_SOURCE = ['word', 'excel', 'onenote', 'powerpoint'];
/**
 * @hidden
 */
export const ALLOWED_TABLE_BLOCK_TAGS = ['article', 'aside', 'blockquote', 'body', 'canvas', 'details', 'div', 'fieldset', 'figure', 'footer', 'form', 'header', 'li', 'main', 'nav', 'noscript', 'section'];
